import {text_mod_3, } from "../text/Text.js";
export const module03 = {
  title:
    "Уроки 10-11. ​Додавання чисел 2–9 до 9 з переходом через 10.​ Додавання чисел 3–9 до 8 з переходом через 10​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_3, },
    ]
  }
